import { useState } from 'react';
import { DesignService, REPORT_REASONS } from '../services/design-service.js';
import { useLocale } from '../hooks/useLocale.jsx';

export function ReportModal({ designId, user, onClose }) {
  const { t } = useLocale();
  const [reason, setReason] = useState('nsfw');
  const [note, setNote] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const canSubmit = !!user && !user.isAnonymous;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit || submitting) return;
    setSubmitting(true);
    setError('');
    try {
      await DesignService.submitReport(designId, reason, note);
      setDone(true);
    } catch (err) {
      console.warn('report failed:', err);
      setError(t('errReportGeneric'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal report-modal" onClick={(e) => e.stopPropagation()}>
        {done ? (
          <div className="report-done">
            <i className="material-symbols-rounded report-done-icon">check_circle</i>
            <h3>{t('reportThanks')}</h3>
            <p>{t('reportThanksDesc')}</p>
            <button className="btn btn-primary" onClick={onClose}>{t('close')}</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <h3>{t('reportTitle')}</h3>
            <p className="report-desc">{t('reportDesc')}</p>
            {!canSubmit && (
              <p className="report-error">{t('reportSignInHint')}</p>
            )}
            <div className="report-reasons">
              {REPORT_REASONS.map((r) => (
                <label key={r} className="report-reason">
                  <input
                    type="radio"
                    name="reason"
                    value={r}
                    checked={reason === r}
                    onChange={(e) => setReason(e.target.value)}
                    disabled={!canSubmit}
                  />
                  <span>{t(`reportReason_${r}`)}</span>
                </label>
              ))}
            </div>
            <textarea
              className="report-note"
              placeholder={t('reportNotePlaceholder')}
              maxLength={500}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              disabled={!canSubmit}
              rows={3}
            />
            {error && <p className="report-error">{error}</p>}
            <div className="report-actions">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                {t('cancel')}
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!canSubmit || submitting}
              >
                {submitting ? t('reportSubmitting') : t('reportSubmit')}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
